import { apiRequest } from './client';
import type { TokenPairResponse } from './auth';
import type {
  AdminAcceptInvitePayload,
  AdminInvitePayload,
  AdminInviteResponse,
  AdminUpdatePayload,
  AdminUser,
  AdminsListResponse,
} from '../types/admins';

export type ListAdminsParams = {
  readonly page?: number;
  readonly page_size?: number;
  readonly search?: string;
};

export function listAdmins(
  params: ListAdminsParams,
  accessToken: string,
): Promise<AdminsListResponse> {
  const { page = 1, page_size = 50, search } = params;
  const query = new URLSearchParams({ page: String(page), page_size: String(page_size) });
  if (search) {
    query.set('search', search);
  }
  return apiRequest<AdminsListResponse>(`/admin/admins?${query.toString()}`, {
    token: accessToken,
  });
}

export function inviteAdmin(
  payload: AdminInvitePayload,
  accessToken: string,
): Promise<AdminInviteResponse> {
  return apiRequest<AdminInviteResponse>('/admin/admins/invite', {
    method: 'POST',
    body: payload,
    token: accessToken,
  });
}

export function updateAdmin(
  userId: string,
  payload: AdminUpdatePayload,
  accessToken: string,
): Promise<AdminUser> {
  return apiRequest<AdminUser>(`/admin/admins/${userId}`, {
    method: 'PATCH',
    body: payload,
    token: accessToken,
  });
}

export function deleteAdmin(userId: string, accessToken: string): Promise<void> {
  return apiRequest<void>(`/admin/admins/${userId}`, {
    method: 'DELETE',
    token: accessToken,
  });
}

export function sendAdminPasswordReset(userId: string, accessToken: string): Promise<void> {
  return apiRequest<void>(`/admin/admins/${userId}/password-reset`, {
    method: 'POST',
    token: accessToken,
  });
}

export function acceptAdminInvite(
  payload: AdminAcceptInvitePayload,
): Promise<TokenPairResponse> {
  return apiRequest<TokenPairResponse>('/admin/admins/invite/accept', {
    method: 'POST',
    body: payload,
  });
}
